import { gsap } from 'gsap'

const STORAGE_KEY = 'rychle-sipy-a-velikonocni-poklad:settings'

/**
 * Check if animations are currently enabled.
 * Reads from the class on <html> which is the source of truth at runtime.
 */
export function areAnimationsEnabled(): boolean {
  return !document.documentElement.classList.contains('disable-animations')
}

/**
 * Apply animation settings globally:
 * - Toggle `.disable-animations` class on <html> (disables CSS animations/transitions)
 * - Set GSAP globalTimeline timeScale (makes JS tweens instant when disabled;
 *   scroll-driven/scrubbed animations are unaffected since ScrollTrigger
 *   controls their progress directly)
 * - Destroy Lenis smooth scroll when disabled (native browser scroll takes over)
 */
export function applyAnimationSettings(enabled: boolean): void {
  document.documentElement.classList.toggle('disable-animations', !enabled)

  gsap.globalTimeline.timeScale(enabled ? 1 : 1000)

  if (!enabled) {
    const lenis = (window as any).__lenis
    if (lenis && typeof lenis.destroy === 'function') {
      lenis.destroy()
      ;(window as any).__lenis = null
    }
  }
}

/**
 * Read the persisted animationsEnabled value from localStorage.
 * Falls back to `!prefers-reduced-motion` if not saved.
 */
export function loadAnimationsEnabled(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      const parsed = JSON.parse(raw)
      if (typeof parsed.animationsEnabled === 'boolean') return parsed.animationsEnabled
    }
  } catch {
    /* ignore */
  }
  return !window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

/**
 * Apply animation settings on app startup (before anything else renders).
 * Call this early in main.ts.
 */
export function initAnimationSettings(): void {
  applyAnimationSettings(loadAnimationsEnabled())
}
